

import { IKnowledge } from '@clickster/constant-definitions/dist-esm/entities/knowledge/types';
import { useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/src/components/ui/shadcn/sheet';

/**
 * ContentDrawer component props
 */
interface ContentDrawerProps {
  isOpen: boolean;
  onOpenChange: (val: boolean) => void;
  instruction: IKnowledge | null;
  readOnly?: boolean;
}

/**
 * ContentDrawer component for displaying knowledge content in a side drawer
 * @param {boolean} isOpen - Whether the drawer is open
 * @param {function} onOpenChange - Function to call when the open state changes
 * @param {IKnowledge | null} instruction - The knowledge instruction to display
 * @param {boolean} readOnly - Whether the content should be read-only
 * @returns {JSX.Element | null} - The rendered component or null if no instruction
 */
export function ContentDrawer({ isOpen, onOpenChange, instruction, readOnly = false }: ContentDrawerProps) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  if (!instruction) return null;

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent
        side="right-wide"
      >
        <div className="h-full flex flex-col">
          <SheetHeader className="sticky bg-white border-b border-gray-200 mt-3">
            <SheetTitle className="text-2xl font-bold">{instruction.name}</SheetTitle>
            {instruction.section && (
              <div className="mt-2">
                <span className="inline-block  rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  {instruction.section}
                </span>
              </div>
            )}
          </SheetHeader>

          {/* Content */}
          <div className="p-6 overflow-y-auto flex-1">
            <div className="prose prose-blue max-w-none">
              <div
                className="text-gray-700 text-lg"
                dangerouslySetInnerHTML={{ __html: instruction.content || '' }}
              />
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
